var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardSalesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.03
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5902 73.0615V81.8583C46.5902 89.3117 39.6568 95.3349 31.1202 95.3349C22.5835 95.3349 15.6068 89.3117 15.6068 81.8583V73.0615C15.6068 80.5149 22.5402 85.8015 31.1202 85.8015C39.6568 85.8015 46.5902 80.4715 46.5902 73.0615Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5833 61.1433C46.5833 63.3099 45.9766 65.3032 44.9366 67.0365C42.38 71.2399 37.1366 73.8833 31.0699 73.8833C25.0032 73.8833 19.7599 71.1965 17.2032 67.0365C16.1632 65.3032 15.5568 63.3099 15.5568 61.1433C15.5568 57.4166 17.29 54.0799 20.0633 51.6533C22.88 49.1833 26.7365 47.7101 31.0265 47.7101C35.3165 47.7101 39.1733 49.2266 41.99 51.6533C44.85 54.0366 46.5833 57.4166 46.5833 61.1433Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5902 61.1433V73.0599C46.5902 80.5133 39.6568 85.7999 31.1202 85.7999C22.5835 85.7999 15.6068 80.4699 15.6068 73.0599V61.1433C15.6068 53.6899 22.5402 47.6667 31.1202 47.6667C35.4102 47.6667 39.267 49.1832 42.0836 51.6099C44.857 54.0365 46.5902 57.4166 46.5902 61.1433Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3335 47.5366V56.4635C95.3335 58.8468 93.4268 60.7966 91.0002 60.8833H82.5067C77.8267 60.8833 73.5368 57.46 73.1468 52.78C72.8868 50.05 73.9267 47.4933 75.7467 45.7166C77.3501 44.07 79.5601 43.1167 81.9867 43.1167H91.0002C93.4268 43.2034 95.3335 45.1532 95.3335 47.5366Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66669 45.5V36.8333C8.66669 25.0467 15.7734 16.8133 26.8234 15.4266C27.95 15.2533 29.12 15.1667 30.3334 15.1667H69.3334C70.46 15.1667 71.5434 15.2099 72.5834 15.3833C83.7634 16.6833 91 24.96 91 36.8333V43.1167H81.9866C79.5599 43.1167 77.3499 44.0699 75.7466 45.7166C73.9266 47.4933 72.8867 50.05 73.1467 52.78C73.5367 57.46 77.8266 60.8833 82.5066 60.8833H91V67.1667C91 80.1667 82.3334 88.8333 69.3334 88.8333H58.5",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardSalesImg);
export default __webpack_public_path__ + "static/media/card-sales-img.669421bcd6abec206e7b9f1551e8706b.svg";
export { ForwardRef as ReactComponent };